import IndexLayout from "../Layouts/IndexLayout";
import MainLayout from "../Layouts/MainLayout";
import PagesLayaut from "../Layouts/PagesLayaut";

import { createBrowserRouter } from "react-router-dom";

import Productos from "../Pages/Productos/Productos";
import Usuarios from "../Pages/Usuarios/Usuarios";
import Banners from "./Banners/Banners";
import Main from "./Main/Main";
import Categorias from "./Categorias/Categorias";
import Codigos from "./Codigos/Codigos";
import PageDetail from "../Pages/PageDetail/PageDetail";
import PageProductos from "./PageProductos/PageProductos";
import Pedidos from "./Pedidos/Pedidos";
import Tienda from "./Tienda/Tienda";
import MetodosDePago from "./MetodosDePago/MetodosDePago";

// >>> IMPORTAMOS LA PAGE DE MENSAJE WHATSAPP (CON LAYOUT DE DASHBOARD)
import MensajeWhatsapp from "./MensajeWhatsapp/MensajeWhatsapp";

// >>> COMPONENTE PÚBLICO DEVELOPER (SE USA EN FOOTER / PÁGINA PRINCIPAL)
import Developer from "../Components/Developer/Developer";

// >>> NUEVO: IMPORTAMOS EL ADMIN DE DEVELOPER (EDICIÓN)
import DeveloperAdmin from "../Pages/Developer/DeveloperAdmin";

// >>> NUEVO: 

// arriba con los imports:
import Sucursales from "./Sucursales/Sucursales";

// >>> NUEVA SECION 1
import Marcas from "./Marcas/Marcas";
import Atributos from "./Atributos/Atributos";
import AtributosInfo from "./AtributosInfo/AtributosInfo";
import Resenas from "./Resenas/Resenas";
import Apariencia from "./Apariencia/Apariencia";


import Error404 from '../Components/ErrorPages/Error404';




export const router = createBrowserRouter(
  [
    // Rutas públicas
    {
      path: "/",
      element: <IndexLayout />,
    },

    // Ruta pública del detalle de producto (sin guard de autenticación)
    {
      path: `/producto/:idProducto/:seoUrl`,
      element: <PagesLayaut />,
      children: [
        { index: true, element: <PageDetail /> },
      ],
    },

    // Rutas de páginas
    {
      path: "/",
      element: <PagesLayaut />,
      children: [
        {
          path: `/productos`,
          element: <PageProductos />,
        },
      ],
    },

    // Rutas de dashboard
    {
      path: "/",
      element: <MainLayout />,
      children: [
        { path: `/dashboard`, element: <Main /> },
        { path: `/dashboard/productos`, element: <Productos /> },
        { path: `/dashboard/usuarios`, element: <Usuarios /> },
        { path: `/dashboard/banners`, element: <Banners /> },
        { path: `/dashboard/categorias`, element: <Categorias /> },
        { path: `/dashboard/promociones`, element: <Codigos /> },
        { path: `/dashboard/pedidos/view?`, element: <Pedidos /> },
        { path: `/dashboard/mi-tienda`, element: <Tienda /> },
        { path: `/dashboard/metodos-de-pago`, element: <MetodosDePago /> },

        // >>> NUEVA RUTA PARA EL MENSAJE WHATSAPP
        { path: `/dashboard/configuracion/whatsapp`, element: <MensajeWhatsapp />,},
        // >>> CAMBIO: ESTA RUTA AHORA ABRE EL ADMIN PARA EDITAR DEVELOPER
        
        {path: `/dashboard/developer`,element: <DeveloperAdmin />,},
        { path: `/dashboard/sucursales`, element: <Sucursales /> },


        { path: `/dashboard/marcas`, element: <Marcas /> },
        { path: `/dashboard/atributos`, element: <Atributos /> },
        { path: `/dashboard/atributos/info`, element: <AtributosInfo /> },
        { path: `/dashboard/resenas`, element: <Resenas /> },
        { path: `/dashboard/apariencia`, element: <Apariencia /> },
        
        { path: '*', element: <Error404 /> }







       // >>> PA 2







      ],
    },
  ],
  // Configuración adicional del Router
  {
    // basename: "/Shop", // ✨ Configuración opcional si quieres desplegar en subcarpeta
  }
);